import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_main_tradePrice--input"] || "myhouse_main_tradePrice--input"} width="7" height="12" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 1l5 5-5 5" stroke="#9AA8C2" strokeWidth="1.1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" /></svg>);